import _ from 'lodash';

import { openDialog } from '../base/dialog';
import { PARTICIPANT_ROLE, getParticipantById } from '../base/participants';
import { showNotification } from '../notifications';

export * from './actions.any';

/**
 * Opens the grant / revoke moderator dialog for a participant, enforcing the
 * plan's moderator limit ({@code moderators_allowed} from the pre-registration
 * API). Revoking is always allowed; granting past the limit shows an upgrade
 * notification instead.
 *
 * @param {string} participantID - The participant to grant / revoke.
 * @returns {Function}
 */
export function openGrantModeratorDialog(participantID: string) {
    return (dispatch: Function, getState: Function) => {
        const state = getState();

        if (_.isNil(state['features/base/jwt']?.jwt)) {
            return;
        }

        // Lazy require: components import from actions, avoid the cycle.
        const { GrantModeratorDialog } = require('./components/web');
        const participant = getParticipantById(state, participantID);
        const moderatorsAllowed = state['features/base/mtApi']?.pregData?.moderators_allowed;
        const totalModerators = state['features/base/participants']
            .filter(p => p.role === PARTICIPANT_ROLE.MODERATOR && !p?.isFakeParticipant);

        if (participant?.role !== PARTICIPANT_ROLE.MODERATOR
                && totalModerators.length >= moderatorsAllowed) {
            const { URL_PREFIX } = state['features/base/config'];

            dispatch(showNotification({
                descriptionArguments: { number: moderatorsAllowed },
                descriptionKey: 'notify.maxGrantModeratorDes',
                titleKey: 'notify.maxGrantModerator',
                customActionNameKey: 'notify.upgradeNow',
                customActionHandler: () => window.open(`${URL_PREFIX}updateSubscription`, '_new')
            }));

            return;
        }

        dispatch(openDialog(GrantModeratorDialog, { participantID }));
    };
}
